import { createNamespacedHelpers } from 'vuex';

export const unRegisterStore = (store, name) => {
  if (store.state[name] != undefined) {
    store.unregisterModule(name);
  }
};

export const registerStore = (store, name, module, preserveState) => {
  if (store.state[name] == undefined) {
    store.registerModule(name, module, { preserveState });
  }

  return {
    namespace: name,
    namespacedHelpers: createNamespacedHelpers(name),
  };
};
